export const REQUESTS_GIFTS_SLICE_NAME = "requestsGifts"
